<template>
    <div class="possible-efforts-sub-menu">
        <div class="switcher">
            <div class="item" :class="{'selected': selectedItem === 'rightProjects'}" @click="selectedItem = 'rightProjects'">
                <span>{{ texts.rightProjects.boksTekst }}</span>
                <!--<i class="far fa-fw fa-arrow-down" v-if="selectedItem === 'rightProjects'"></i>
                <i class="far fa-fw fa-arrow-right" v-else></i>-->
            </div>
            <div class="item" :class="{'selected': selectedItem === 'mostImportant'}" @click="selectedItem = 'mostImportant'">
                <span>{{ texts.mostImportantFirst.boksTekst }}</span>
                <!--<i class="far fa-fw fa-arrow-down" v-if="selectedItem === 'mostImportant'"></i>
                <i class="far fa-fw fa-arrow-right" v-else></i>-->
            </div>
        </div>
        <div v-show="selectedItem === 'rightProjects'">
            <div class="lg">
                {{ texts.rightProjects.tykTekst1 }}
                {{ projectsRightProjectsRange[0] | currency }} til {{ projectsRightProjectsRange[1] | currency }}
            </div>
            <div class="sub" v-html="texts.rightProjects.tyndTekst1">
                {{ texts.rightProjects.tyndTekst1 }}
            </div>
            <div class="g-table-wrapper">
                <div class="placeholder">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="customers.customerRevenue" />
                        Arbejdes der med de rigtige opgaver?
                    </div>
                    <div class="placeholder">
                        
                        <vue-good-table
                            :columns="rightProjectsColumns"
                            :rows="data.right_projects.table"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div class="coverage-cell" v-if="props.column.field == 'coverage_percent'">
                                    {{ props.row.coverage_percent | coveragePercent }} 
                                    <div
                                        v-if="props.row.coverage_percent !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_percent < $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': $options.filters.rounded(props.row.coverage_percent) >= $store.state.config.companyMeta.settings.coverage_percent.high.value}"
                                    />
                                </div>
                                <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name">
                                    {{ props.row.name }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage'">
                                    {{ props.row.coverage | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'invoices_total'">
                                    {{ props.row.invoices_total | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'timelog_hours_total'">
                                    {{ props.row.timelog_hours_total | number }}
                                </div>
                                <div class="coverage-cell" v-else-if="props.column.field == 'coverage_per_hour'">
                                    {{ props.row.coverage_per_hour | currency }} 
                                    <div
                                        v-if="props.row.coverage_per_hour !== null"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />
                                </div>
                                <div v-else :title="props.formattedRow[props.column.field]">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                    </div>
                </div>
            </div>
            <div class="foot">
                <div class="button" @click="goToRoute('ProjectsLearning', 'projectTypeRevenue')">
                    Gå til alle opgavetyper &rarr;
                </div>
            </div>
        </div>
        <div v-show="selectedItem === 'mostImportant'">
            <div class="lg">
                {{ texts.mostImportantFirst.tykTekst1 }}
                <table>
                    <thead>
                        <tr>
                            <th align="left" style="padding:10px 10px 0 10px;">Opgavetype</th>
                            <th align="right" style="padding:10px 10px 0 10px;">DB pr. time</th>
                            <th align="right" style="padding:10px 10px 0 10px;">Samlet DB</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td align="left" style="padding:10px 10px 0 10px;font-weight:normal;">
                                {{ projectsMostImportantRange[0].name }}
                            </td>
                            <td align="right" style="padding:10px 10px 0 10px;">
                                <p style="display:inline-block;color:green;" v-if="projectsMostImportantRange[0].coverage_per_hour_change > 0">&uarr; {{ projectsMostImportantRange[0].coverage_per_hour_change | currency }}</p>
                                <p style="display:inline-block;color:red;" v-else>&darr; {{ Math.abs(projectsMostImportantRange[0].coverage_per_hour_change) | currency }}</p>
                            </td>
                            <td align="right" style="padding:10px 10px 0 10px;">
                                <p style="display:inline-block;color:green;margin-left:10px;" v-if="projectsMostImportantRange[0].coverage_change > 0">&uarr; {{ projectsMostImportantRange[0].coverage_change | currency }}</p>
                                <p style="display:inline-block;color:red;margin-left:10px;" v-else>&darr; {{ Math.abs(projectsMostImportantRange[0].coverage_change) | currency }}</p>
                            </td>
                        </tr>
                        <tr v-if="projectsMostImportantRange.lenght > 1">
                            <td align="left" style="padding:10px 10px 0 10px;font-weight:normal;">
                                {{ projectsMostImportantRange[1].name }}
                            </td>
                            <td align="right" style="padding:10px 10px 0 10px;">
                                <p style="display:inline-block;color:green;" v-if="projectsMostImportantRange[1].coverage_per_hour_change > 0">&uarr; {{ projectsMostImportantRange[1].coverage_per_hour_change | currency }}</p>
                                <p style="display:inline-block;color:red;" v-else>&darr; {{ Math.abs(projectsMostImportantRange[1].coverage_per_hour_change) | currency }}</p>
                            </td>
                            <td align="right" style="padding:10px 10px 0 10px;">
                                <p style="display:inline-block;color:green;margin-left:10px;" v-if="projectsMostImportantRange[1].coverage_change > 0">&uarr; {{ projectsMostImportantRange[1].coverage_change | currency }}</p>
                                <p style="display:inline-block;color:red;margin-left:10px;" v-else>&darr; {{ Math.abs(projectsMostImportantRange[1].coverage_change) | currency }}</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="sub" v-html="texts.mostImportantFirst.tyndTekst1">
                {{ texts.mostImportantFirst.tyndTekst1 }}
            </div>

            <div class="g-table-wrapper">
                <div class="placeholder">
                    <div class="placeholder__heading">
                        Udviklingen i DB / DB pr. time
                    </div>
                    <div class="placeholder">

                        <vue-good-table
                            :columns="mostImportantColumns"
                            :rows="data.most_important.table.values"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="mostImportantSortOptions"
                            :styleClass="styleClass"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div v-if="props.column.field == 'coverage.progress_percent'" style="text-align:left;">
                                    <span v-if="props.row.coverage.progress_percent >= 5" class="color-good">
                                        <i class="fas fa-arrow-up" />
                                    </span>
                                    <span v-else-if="props.row.coverage_progress_percent === 0 || props.row.coverage_progress_percent > -5 && props.row.coverage_progress_percent < 5">
                                        <i class="fas fa-arrow-right color-avg" />
                                    </span>
                                    <span v-else class="color-bad">
                                        <i class="fas fa-arrow-down" />
                                    </span>
                                </div>
                                <div v-else-if="props.column.field == 'coverage_per_hour.progress_percent'" style="text-align:left;">
                                    <span v-if="props.row.coverage_per_hour.progress_percent >= 5" class="color-good">
                                        <i class="fas fa-arrow-up" />
                                    </span>
                                    <span v-else-if="props.row.coverage_per_hour_progress_percent === 0 || props.row.coverage_per_hour_progress_percent > -5 && props.row.coverage_per_hour_progress_percent < 5">
                                        <i class="fas fa-arrow-right color-avg" />
                                    </span>
                                    <span v-else class="color-bad">
                                        <i class="fas fa-arrow-down" />
                                    </span>
                                </div>
                                <div v-else-if="props.column.field == 'projects_count'" style="text-align:left;">
                                    {{ props.row.projects_count | number }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage_total'" style="text-align:left;">
                                    {{ props.row.coverage_total | currency }}
                                </div>
                                <div v-else-if="props.column.field == 'coverage_per_hour_total'" style="text-align:left;">
                                    <div
                                        v-if="props.row.coverage_per_hour_total"
                                        class="coverage-indicator"
                                        :class="{'bad': props.row.coverage_per_hour_total < $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': $options.filters.rounded(props.row.coverage_per_hour_total) >= $store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': $options.filters.rounded(props.row.coverage_per_hour_total) >= $store.state.config.companyMeta.settings.coverage_per_hour.high.value}"
                                    />{{ props.row.coverage_per_hour_total | currency }} 
                                </div>
                                <div v-else-if="props.column.field == 'name'" class="table-column__description" :title="props.row.name ? props.row.name : '-'">
                                    {{ props.row.name ? props.row.name : '-' }}
                                </div>
                                <div v-else :title="props.formattedRow[props.column.field]">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                    </div>
                </div>
            </div>
            <div class="foot">
                <div class="button" @click="goToRoute('ProjectsLearning', 'projectTypeGraphs')">
                    Gå til udviklingen i DB / DB pr. time &rarr;
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['selectedBox', 'data', 'projectsRightProjectsRange', 'projectsMostImportantRange', 'texts'],
    data () {
        return {
            selectedItem: 'rightProjects',
            rightProjectsColumns: [
                { label: 'Opgavetype', field: 'name', type: 'string' },
                { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'Antal timer', field: 'timelog_hours_total', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }
            ],
            mostImportantColumns: [
                { label: 'Opgavetype', field: 'name', type: 'string' },
                { label: 'Antal', field: 'projects_count', type: 'number' },
                { label: 'DB (sum)', field: 'coverage_total', type: 'number' },
                { label: 'DB udv.', field: 'coverage.progress_percent', type: 'number' },
                { label: 'DB/time (sum)', field: 'coverage_per_hour_total', type: 'number' },
                { label: 'DB/time udv.', field: 'coverage_per_hour.progress_percent', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            mostImportantSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_total',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        }
    },
    methods: {
        goToRoute (parent, child) {
            this.$router.push({
                name: parent,
                params: {
                    selectedItem: child
                },
                query: {
                    tab: child
                }
            })
        }
    },
    watch: {
        selectedBox () {
            if (this.selectedBox) {
                this.selectedItem = this.selectedBox
            } else {
                this.selectedItem = 'rightProjects'
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// projects.vue?4b2e7c32